export default {
	ADD_SKILL(state, item) {
		state.skills.push(item);
	},
	SET_SKILLS(state, skills) {
		state.skills = skills;
	},
	UPDATE_SKILL(state, product) {
		const productIndex = state.skills.findIndex((p) => p.id === product.id);
		Object.assign(state.skills[productIndex], product);
	},
	REMOVE_SKILL(state, itemId) {
		const ItemIndex = state.skills.findIndex((p) => p.id === itemId);
		state.skills.splice(ItemIndex, 1);
	},
	ADD_SKILL_VISIT_POINT(state, skills) {
		let newSkillList;
		if (Array.isArray(skills)) {
			newSkillList = state.listSelectedSkills.concat(
				skills.filter((element) => state.listSelectedSkills.find((e) => e.id === element.id) === undefined)
			);
		} else {
			newSkillList = state.listSelectedSkills.concat(skills);
		}
		state.listSelectedSkills = newSkillList;
	},
	SET_ASSIGNED_SKILL(state, items) {
		let arrayNew = state.listSelectedSkills.concat(
			items.filter((element) => state.listSelectedSkills.find((e) => e.id === element.id) === undefined)
		);
		state.listSelectedSkills = arrayNew;
	},
	REMOVE_ASSIGNED_SKILL(state, id) {
		const itemIndex = state.listSelectedSkills.findIndex((skill) => skill.id === id);
		state.listSelectedSkills.splice(itemIndex, 1);
	},
	REMOVE_ALL_ASSIGNED_SKILL(state) {
		state.listSelectedSkills = [];
	},
	ADD_ID_SKILL(state, id) {
		state.skillIds.push(id);
	},
	REMOVE_ID_SKILL(state, item) {
		const itemIndex = state.skillIds.findIndex((p) => p.id === item.id);
		if (itemIndex >= 0) {
			state.skillIds.splice(itemIndex, 1);
		}
	},
	ADD_SKILL_CHECKED(state, item) {
		const itemIndex = state.checkedSkills.findIndex((p) => p.id === item.id);
		if (itemIndex === -1) {
			state.checkedSkills.push(item);
		}
	},
	SET_SKILL_CHECKED(state, items) {
		state.checkedSkills = items;
	},
	REMOVE_SKILL_CHECKED(state, item) {
		const itemIndex = state.checkedSkills.findIndex((p) => p.id === item.id);
		if (itemIndex >= 0) {
			state.checkedSkills.splice(itemIndex, 1);
		}
	},
	REMOVE_ALL_SKILL_CHECKED(state) {
		state.checkedSkills = [];
	},
};
